// 任务管理
export const GET_PROVICE_ENTS = 'GET_PROVICE_ENTS';
export const GET_USER = 'GET_USER';
export const GET_LIVING_NUM = 'GET_LIVING_NUM';
export const SET_SOCKET_MSG = 'SET_SOCKET_MSG';
export const SET_USER_MENU = 'SET_USER_MENU';
